export default __webpack_public_path__ + "static/media/O-017.e5a347ae.png";